// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","carrinho":"Header_carrinho__htcq9","containerCarrinho":"Header_containerCarrinho__OfLcn","contador":"Header_contador__4SwOI"};